export default "__VITE_ASSET__Cxaz6Xl9__"